import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { makeServer } from "./mirage/server"
import 'vue-final-modal/style.css';
require('@/assets/css/main.scss');
require('@/assets/css/main.css');
makeServer()
createApp(App).mount('#app')
